import posthog from 'posthog-js';
import type { PostHog } from 'posthog-js';

import { config } from '@/config';

/**
 * The only module that touches posthog-js (ADR 0027). Without a key the client
 * is never initialised: no network calls, no cookies, and the budget model
 * stays at the control defaults. Playwright pins the key empty for that reason.
 */

let client: PostHog | null | undefined;

export const getPostHog = (): PostHog | null => {
  if (client !== undefined) return client;
  if (!config.posthogKey) {
    client = null;
    return client;
  }
  client =
    posthog.init(config.posthogKey, {
      api_host: config.posthogHost,
      // The events we care about are the explicit Financials ones below —
      // autocapture noise would drown them.
      autocapture: false,
      capture_pageview: true,
      persistence: 'localStorage',
    }) ?? null;
  return client;
};

/** No-op when analytics is disabled — call sites never branch. */
export const captureEvent = (event: string, properties?: Record<string, unknown>): void => {
  getPostHog()?.capture(event, properties);
};
